"use strict";
/**
 * @swagger
 * components:
 *   schemas:
 *     Document:
 *       type: object
 *       required:
 *       - documentID
 *       properties:
 *         documentID:
 *           type: integer
 *           example: 99997777
 *         metadata:
 *           $ref: '#/components/schemas/Metadata'
 */
Object.defineProperty(exports, "__esModule", { value: true });
